import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) =>
  state.speedControlBlock || initialState;

export const selectSpeedControlBlockData = createSelector(
  [selectSlice],
  state => state.data,
);

export const selectSpeedControlBlockIsLoading = createSelector(
  [selectSlice],
  state => state.isLoading,
);
